 <template>
	<div>
		<v-row class="float-right" style="margin: 10px; padding: 10px; border: 1px solid #D3D3D3; border-radius: 43px; width: fit-content;">
			<v-col class="pa-0 mr-4 d-flex align-center">
				<v-icon>mdi-account-circle</v-icon>
			</v-col>
			<v-col class="pa-0 pt-2 pr-2 d-flex flex-column justify-start align-center">
				<span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
					{{ data.solicitante }}<br>{{ data.dni }}
				</span>
			</v-col>
		</v-row>
	</div>
</template>

<script>
export default {
  name: 'DatosSolicitante',
	props: ['data'],
  data () {
    return {
			nombreUsuario() {
				return `${this.data.nombre} ${this.data.apellido1} ${this.data.apellido2}`;
			},
			dniUsuario() {
				return this.data.dni;
			}
		}
	}
}
</script>

<style scoped>
.v-icon {
	color: #124d91;
	font-size: 62px;
}
</style>